import { HttpClient } from '@remodeling/base';
import {
  GetConsultInfoRequest,
  GetConsultInfoResponse,
  GetConsultListRequest,
  GetConsultListResponse,
  UploadConsultTempImageRequest,
  UploadConsultTempImageResponse,
} from '../../model';

export class GetConsultListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetConsultListRequest) {
    return await this.httpClient.request<GetConsultListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/manager/${req.userId}`,
      body: req,
    });
  }
}

export class UploadConsultTempImageGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: UploadConsultTempImageRequest) {
    return await this.httpClient.request<UploadConsultTempImageResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/consults/temp/image`,
      body: req,
    });
  }
}

export class GetConsultInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req?: GetConsultInfoRequest) {
    return await this.httpClient.request<GetConsultInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/consults/info`,
      body: req,
    });
  }
}
